import * as ActionTypes from './actionTypes'

export const createSurvey = ({ survey }) => ({ type: ActionTypes.surveyCreate, survey })
